module.exports = __webpack_public_path__ + "static/media/a34.21c192c0.pdf";